import React, { useEffect } from "react";
import Title from "./Components/Title";
import DefaultLayout from "../Containers/Layout/DefaultLayout";

const AlbumListeningEvent = () => {
  var album = "https://streams.radiomast.io/station/0e4a27c6-dea2-416d-8852-9df0d0a8690f/player/widget?t=default&s=02b2a5fa-50fa-4212-a817-55700343a7f5";
  useEffect(() => {
    var addScript = document.createElement("script");
    addScript.setAttribute(
      "src",
      "//rumbletalk.com/client/?B_aLnmdZ"
    );
    document.body.appendChild(addScript);
  }, []);
  return (
    <div className="page sonos">
      <Title value="Album Listening Event" />
      <DefaultLayout
        disablePlayer
        disableBanner
        disableNavItems
      >
      <main className="sonos-lander">
        <section className="hero">
          <iframe title="radiomast-player" style={{ height: "500px", flex:1 }} src={album} width="360" scrolling="no" frameBorder="0" allow="autoplay" ></iframe>
          <div style={{ height: "500px", flex:1 }} id="rumble-container"><div id="rt-2ce7eea6437e4f137a65ba95f2b41672"></div></div>
        </section>
      </main>
      </DefaultLayout>
    </div>
  );
};

export default AlbumListeningEvent;
